module.exports = __webpack_public_path__ + "images/copy.b2e03c743a633f59e2facfdb3984b2c8.png";